module.exports = __webpack_public_path__ + "static/media/hvac.f0d94c8a.svg";